<template>
    <div>
        <!-- ElementUI 顶部导航栏 -->
        <el-header class="hea" style=" height: 90px !important;">
            <div class="logo cursor" @click="toIndex" v-show="logo">
                <img :src="$img(logo)" alt="" />
            </div>
            <div class="search flx alc jsb" @click="toSearch" v-if="showSearch">
                <div class="inp">
                    <input type="text" placeholder="请输入搜索关键词" />
                </div>
                <div class="searchBtn">
                    搜索
                </div>
            </div>
            <div class="pubs flx alc">
                <!--  <div class="flx alc" style="flex-shrink: 0;" v-if="isLogin">
                    <div class="pubItem" @click="acAdd" v-if="admin_rbac.includes('1')">
                        +发布活动
                    </div>
                    <div class="shu" v-if="admin_rbac.includes('1')"></div>
                    <div class="pubItem" v-if="admin_rbac.includes('2')" @click="zpAdd">
                        +发布招聘
                    </div>
                    <div class="shu" v-if="admin_rbac.includes('2')"></div>
                </div> -->
                <div class="flx alc" style="flex-shrink: 0;">
                    <div class="pubItem" @click="startCount">
                        +发布活动
                    </div>
                    <div class="shu"></div>
                    <div class="pubItem" @click="startCount">
                        +发布招聘
                    </div>
                    <div class="shu"></div>
                </div>
                <div class="pubItem" @click="toshop">商家中心</div>
                <div class="shu"></div>
                <div class="pubItem" @click="logd" v-if="!isLogin">
                    登录/注册
                </div>
                <div class="pubItem" @click="logout" v-if="isLogin">
                    退出登录
                </div>
                <div class="register" style="height: 90px;line-height: 90px;" @click="tocenter">
                    个人中心
                </div>
            </div>
        </el-header>

        <div class="maskt" v-if="showno">
            <div class="maski" style=" width: 274px;height: 225px !important; box-sizing: border-box; padding: 30px 17px 20px 18px;">
                <div class="mttitle flx alc">
                    <div class="mtword" style="font-size: 18px;margin-right: 4px;">
                        提示
                    </div>
                   <!-- <div class="mtcount">
                        {{seconds}}s后自动跳转注册页面
                    </div> -->
                </div>
                <div class="mtcontent" style=" font-size: 15px;color: #666666;margin-top: 10px;line-height: 1.5 !important;">
                    <span style="color: #FF0F23;font-size: 15px;padding-right: 4px;">*</span>未注册商家:前往【商家中心】完成注册认证;<br/><span style="color: #FF0F23;font-size: 15px;padding-right: 4px;">*</span>已认证商家:直接进入【商家中心】即可使用发布功能。
                </div>
                <div class="mtbtns flx jsb alc">
                    <div class="mtbtnLeft" style=" width: 108px;height: 36px;border-radius: 2px;border: 1px solid #D9D9D9;font-size: 14px;line-height: 36px;" @click="closemask">
                        取消
                    </div>
                    <div class="mtbtnRight" style=" width: 108px;height: 36px;background: #007AFF;border-radius: 2px;font-size: 14px;line-height: 36px;" @click="toLog">
                        去注册/登录
                    </div>
                </div>
            </div>

        </div>
    </div>
</template>
<script>
    import {
        getConfig,
        sendCode,
        phoneLogin,
        codeLogin,
        userInfo
    } from "@/api/index.js"
    import Login from './login.vue'
    import Register from './register.vue'
    import Forgets from './forgets.vue'
    export default {
        name: 'Header',
        components: {
            Login,
            Register,
            Forgets
        },
        data() {
            return {
                showno: false,
                showfo: false,
                showRe: false,
                showLogin: false,
                inpType: "password",
                logo: "",
                cur: 0,
                phone: "",
                codeTxct: "获取验证码",
                code: "",
                sending: false,
                hasRead: false,
                isCountDown: false, // 是否正在倒计时
                count: 60, // 倒计时秒数
                timer: null, // 定时器
                pwd: "",
                show: true,
                isLogin: false,
                showSearch: true,
                level: 0,
                admin_rbac: "",
                identity: 0,
                dialogVisible: false,
                seconds: 5,
                timer1:null
            }
        },
        watch: {
            $route: {
                handler(to, from) {
                    this.getConfig()
                    if (to.name == 'searchResult') {
                        this.showSearch = false
                    } else {
                        this.showSearch = true
                    }
                    let token = localStorage.getItem("token")
                    console.log('token', token)
                    if (!token) {
                        this.isLogin = false
                    } else {

                    }
                },
                deep: true
            }
        },
        created() {
            let that = this
            // that.getUser()
            that.getConfig()
            let token = localStorage.getItem('token')
            console.log("token", token)
            if (token) {
                that.isLogin = true
                that.showLogin = false
            }
        },
        beforeDestroy() {
            // if (this.timer1) {
            //     clearInterval(this.timer1)
            // }
        },
        methods: {
            closemask(){
              this.showno = false
                // window.clearInterval(this.timer1) 
            },
            startCount() {
                let that = this
                that.showno = true
                // that.timer1 = setInterval(() => {
                //     if (that.seconds > 0) {
                //         that.seconds -= 1
                //     } else {
                //         window.clearInterval(that.timer1)
                //         that.seconds = 5
                //         that.showno = false
                //         window.open('https://shop.hrxsl.com?source=register', '_blank');
                //     }
                // }, 1000)
            },
            toLog() {
                // window.clearInterval(that.timer1)
                window.open('https://shop.hrxsl.com?source=register', '_blank');
            },
            alerts() {
                let that = this

            },
            logd() {
                this.$bus.$emit('openLoginModal')
            },
            toregister(e) {
                if (e < 4) {
                    this.identity = 0
                } else {
                    this.identity = 1
                }
                this.showRe = true
            },
            toforgets(e) {
                if (e < 4) {
                    this.identity = 0
                } else {
                    this.identity = 1
                }
                this.showfo = true
            },
            toIndex() {
                window.location.href = "https://hrxsl.com/"
            },
            logout() {
                let that = this
                that.$confirm('确定要退出当前账号吗?', ' ', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    localStorage.removeItem('token')
                    localStorage.removeItem('user_id')
                    window.location.href = "https://hrxsl.com/"
                }).catch(() => {

                });
            },
            tovery() {
                this.$router.replace('/verify')
            },
            tocenter() {
                this.$router.push('/mine')
            },
            toshop() {
                window.location.href = "http://shop.hrxsl.com"
            },
            toSearch() {
                this.$router.push('/searchResult')
            },
            acAdd() {
                // this.$router.push('/AddActivity')
            },
            zpAdd() {
                // this.$router.push('/addposition')
            },

            getConfig() {
                let that = this
                getConfig().then((res) => {
                    console.log(res)
                    if (res.code == 1) {
                        that.logo = res.data.logo_pc
                    }
                })
            }
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
    .mtbtns {
        margin-top: 16px;
    }

    .mtbtnRight {
       
        color: #FFFFFF;
        text-align: center;
        cursor: pointer;
    }

    .mtbtnLeft {
        color: #999999;
        text-align: center;
        cursor: pointer;
    }

    .mtcontent {
       
        text-align: left;
        line-height: 1.5;
    }

    .mtword {
        font-weight: 600;
        
    }

    .mtcount {
        font-size: 12px;
        color: #999999;
    }

    .el-icon-circle-close {
        color: #fff;
        font-size: 24px;
        position: absolute;
        top: 0;
        right: -46px;
        cursor: pointer;
    }

    .maskt {
        width: 100%;
        height: 100%;
        background-color: rgba(0, 0, 0, .5);
        position: fixed;
        z-index: 7998 !important;
    }

    .maski {
       
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        background: url("https://hrxsl.com/pcImages/toshopbk.png") no-repeat;
        background-size: 100% 100%;
       
    }

    /* .maski img {
        width: 100%;
        height: 100%;
    } */

    .wechat {
        margin-top: 40px;
        font-weight: 500;
        font-size: 20px;
        color: #333333;
    }

    .wechat img {
        width: 30px;
        height: 30px;
        margin-right: 10px;
    }

    .inner {
        width: 100%;
        height: 100%;
        background: #007AFF;
    }

    .rule {
        font-weight: 500;
        font-size: 12px;
        color: #333333;
    }

    .squ {
        width: 14px;
        height: 14px;
        border-radius: 1px;
        border: 1px solid #D9D9D9;
        margin-right: 8px;
        box-sizing: border-box;
        padding: 2px;
    }

    .Loginbtn {
        margin-bottom: 20px;
        width: 100%;
        height: 48px;
        background: linear-gradient(90deg, #4096FF 0%, #1677FF 100%);
        border-radius: 24px;
        text-align: center;
        line-height: 48px;
        font-weight: 500;
        font-size: 16px;
        color: #FFFFFF;
        margin-top: 96px;
    }

    .sendCode {
        width: 91px;
        height: 48px;
        background: #F6F7F9;
        border-radius: 24px;
        text-align: center;
        line-height: 48px;
        font-size: 12px;
        color: #666666;
        font-weight: 500;
    }

    .phoneInp img {
        width: 18px;
        height: 18px;
    }

    .phoneInp input {
        flex: 1;
        box-sizing: border-box;
        padding: 0 8px;
        height: 100%;
        font-size: 14px;
        border: none !important;
        outline: none !important;
        background: transparent !important;
    }

    .phoneInp {
        width: 100%;
        height: 48px;
        background: #F6F7F9;
        border-radius: 24px;
        box-sizing: border-box;
        padding: 0 20px;
    }

    .phoneLogin {
        margin-top: 50px;
    }

    .cmActive {
        font-weight: 500 !important;
        font-size: 20px !important;
        color: #007AFF !important;
    }

    .heng {
        width: 32px;
        height: 3px;
        background: #007AFF;
        border-radius: 2px;
        margin: 10px auto 0;
    }

    .changeMetohds {
        box-sizing: border-box;
        padding: 20px 0;
    }

    .cmName {
        font-weight: 500;
        font-size: 20px;
        color: #999999;
    }

    .cmItem {
        margin: 0 24px;
        cursor: pointer;
    }

    .closeBtn {
        position: absolute;
        right: -50px;
        top: 0;
        cursor: pointer;
    }

    .logMethod img {
        width: 100%;
        height: 100%;
    }

    .logMethod {
        cursor: pointer;
        position: absolute;
        top: 0;
        right: 0;
        width: 55px;
        height: 55px;
    }

    /* .logContent {
        width: 420px;
        height: 562px;
        background: #fff;
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
        border-radius: 20px;
        box-sizing: border-box;
        padding: 30px;
    } */

    .logins {
        /* width: calc(100vw / 0.85);
        height: calc(100vh / 0.85); */
        width: 100vw;
        height: 100vh;
        background: rgba(0, 0, 0, 0.5);
        position: fixed;
        left: 0;
        top: 0;
        z-index: 116 !important;
    }

    .el-submenu__title:hover {
        background: transparent !important;
    }

    .el-menu--popup-bottom-start {
        margin-top: 0 !important;
    }

    .el-menu--popup {
        padding: 0 !important;
    }

    .el-menu--horizontal>.el-menu-item.is-active {
        border: none !important;
    }

    .el-menu {
        background-color: transparent !important;
    }

    .pubItem {
        font-weight: 500;
        font-size: 16px;
        color: #151515;
        padding: 0 24px;
        cursor: pointer;
        flex-shrink: 0;
    }

    .el-header {
        padding: 0 !important;
    }

    .register {
        width: 83px;
        background: #007AFF;
        text-align: center;
        line-height: 90px;
        font-weight: 500;
        font-size: 16px;
        color: #FFFFFF;
        cursor: pointer;
        flex-shrink: 0;
    }

    .shu {
        width: 1px;
        height: 14px;
        background: #D9D9D9;
    }

    .pubs {
        flex: 1;
        justify-content: flex-end;
    }

    .search {
        margin-left: 259px;
    }

    .inp {
        width: 380px;
        height: 50px;
        border: 1px solid #007AFF;
    }

    .inp input {
        width: 100%;
        height: 100%;
        border: none;
        outline: none;
        font-weight: 500;
        font-size: 16px;
        box-sizing: border-box;
        padding: 0 10px;
    }

    .searchBtn {
        width: 86px;
        height: 50px;
        background: #007AFF;
        border-radius: 0px 0px 0px 0px;
        border: 1px solid #007AFF;
        text-align: center;
        line-height: 50px;
        font-weight: 500;
        font-size: 18px;
        color: #FFFFFF;
    }

    .hea {
        background: pink;

        background: #FFFFFF;
        box-shadow: 0px 6px 8px 0px rgba(0, 0, 0, 0.04);
        display: flex;
        align-items: center;
        box-sizing: border-box;
        padding-left: 230px !important;
        position: fixed;
        left: 0;
        top: 0;
        z-index: 111;
        width: 100%;
    }

    .logo {
        width: 162px;
        height: 55px;

    }

    .logo img {
        width: 100%;
        height: 100%;
    }
</style>